export default __webpack_public_path__ + "static/nav2-a50f08cf7ddb2307d4242ef34e037c4a.jpg";